import React, { Component } from 'react';
import PropTypes from 'prop-types';
import schema from '../../../../schema/appcenter.json';

class ActivationFragment extends Component {
  componentDidMount = async () => {
    if (typeof window !== 'undefined') {
      const { insertFragment } = require('@paypalcorp/manage-client-fragment');
      const { nonce } = window.__INITIAL_STATE__;
      const { location } = this.props;
      const product = location.pathname.split('/').pop();
      const { fpti } = schema.tools.find(obj => obj.location === product);
      const options = { schema: fpti };
      const name = 'activation-fragment';
      const targetElement = document.getElementById('activation-appcenter');
      await insertFragment(name, targetElement, nonce, options);
    }
  };

  render() {
    return (
      <section id="activation-appcenter-container">
        <div id="activation-appcenter" />
      </section>
    );
  }
}

ActivationFragment.propTypes = {
  location: PropTypes.object.isRequired
};

export default ActivationFragment;
